__turbopack_context__.v({
  "root": "HomePageContainer-module-scss-module__X8HP6W__root",
});
